import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MessengerService } from '@services/messenger/messenger.service';
import { AccommodationWizardIdsService } from '@services/accommodation-wizard-ids-service/accommodation-wizard-ids.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { DialogService } from '@services/dialog/dialog.service';
import { Models } from '@ibexfusion/models';
import { ImportService } from '@services/imports/import.service';
import { AnalyticLogsService } from '@services/analytic-logs/analytic-logs.service';
import { ScreenService } from '@services/screens/screen.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { CustomerService } from '@services/customers/customer.service';

@Component({
    selector: 'app-customer-eraser',
    templateUrl: './customer-eraser.component.html',
    styleUrls: ['./customer-eraser.component.scss'],
    providers: [
        DialogService, CustomerService,
        ImportService, ScreenService, AnalyticLogsService,
        AccommodationWizardIdsService
    ],
    standalone: false
})
export class CustomerEraserComponent implements OnInit, OnDestroy {

  public title = '';

  public progressing = false;
  public done = false;
  public statusInfo = null;
  public error = null;
  public isTest = false;
  public cancel = null;
  public protocol: any = {};
  public isLive: any;
  private apiKey = 'Vwvlo4aZMj|5Ht8g3WEoQ4W9mk6YpE16pP5lITtL8WS7R7ESbMC6rglHckoqFzMNL5j08Kq26Q1sx+xtyBNyDHT3RWEuf55Xw==';

  constructor(
    private router: Router,
    private snackbar: SnackbarService,
    public dialogRef: MatDialogRef<CustomerEraserComponent>,
    public dialogService: DialogService,
    private ms: MessengerService,
    private customerService: CustomerService,
    private importService: ImportService,
    private screenService: ScreenService,
    private analyticLogsService: AnalyticLogsService,
    private http: HttpClient,
    private accommodationWizardIdsService: AccommodationWizardIdsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isLive = this.ms.getActiveAPI() === 'live';
  }

  ngOnInit() {
    this.title = this.data && this.data.customer ? this.data.customer.company : '';
  }

  public ngOnDestroy() {
    this.cancel = true;
  }

  public onClose() {
    if (this.done && !this.isTest) {
      if (this.progressing) {
        this.snackbar.open('Still working, please wait!');
        return;
      }
      this.cancel = true;
      this.dialogRef.close();
      this.router.navigate(['customers']);
    } else {
      this.cancel = true;
      this.dialogRef.close();
    }
  }

  public onRemove(test = false) {
    this.isTest = test;
    this.initProtocol();
    if (this.isTest) {
      this.removeAllData();
      return;
    }
    const random = this.generateRandom(4);
    this.dialogService.confirm(
      'Are you really sure to performe it?<br/> Enter the random code to confirm: ' + random,
      'Delete Customer: ' + this.title,
      true).then(result => {
      if (result && result === random) {
        this.removeAllData();
      } else {
        console.log('wrong random nummber');
      }
    });
  }

  public removeAllData() {
    this.progressing = true;
    if (!this.isTest) {
      this.dialogRef.disableClose = true;
    }
    this.protocol.importIds = this.data.customer.importIds || [];
    this.protocol.screenUuids = this.data.customer.screenUuids || [];
    if (this.protocol.screenUuids > 100) {
      this.snackbar.open('Sorry, you can not yet remove more then 100 screens!!');
      return;
    }

    this.removeByIds(this.customerService, [this.data.customer._id], true).then(() => {
      this.protocol.log.push('Customer removed');

      this.statusInfo = 'Remvoing Imports (' + this.protocol.importIds.length + ')';
      return this.removeImports().then(countImports => {

        this.protocol.log.push('Imports (' + countImports + '/' + this.protocol.importIds.length + ')');

        this.statusInfo = 'Removing Screens';
        return this.removeScreens().then(countScreens => {
          this.protocol.log.push('Screens (' + countScreens + '/' + this.protocol.screenIds.length + ')');

          this.statusInfo = 'Search analytics logs ...';
          return this.removeAnalyticLogs().then(() => {
            this.protocol.log.push('Analytic Logs (' + this.protocol.analyticLogsCount + ')');

            if (this.data.customer.compositionNames && this.data.customer.compositionNames.length) {
              this.protocol.log.push('Please check legacy-compositions: ' + this.data.customer.compositionNames);
            }
            return this.saveProtocol().then(() => {
              this.dialogRef.disableClose = false;
              this.statusInfo = '(-: *** Success *** :-)';
              this.progressing = false;
              this.done = true;
            });
          });
        });
      });
    }).catch(err => {
      this.dialogRef.disableClose = false;
      this.progressing = false;
      this.done = true;
      return this.saveProtocol(err);
    });
  }

  private removeImports(): Promise<any> {
    return this.removeByIds(this.importService, this.protocol.importIds);
  }

  private removeScreens(): Promise<any> {
    // hook removes screenSettings and fake-jsons
    if (!this.protocol.screenUuids.length) {
      return Promise.resolve(0);
    }
    return this.screenService.find(0, 100, { uuid: { $in: this.protocol.screenUuids } }).then(screens => {
      console.log('screens: ', screens);
      if (!screens || !screens.data) {
        return Promise.resolve(true);
      }
      screens.data.map(screen => {
        this.protocol.screenIds.push(screen._id);
      });
      return this.removeByIds(this.screenService, this.protocol.screenIds);
    })

  }

  private removeAnalyticLogs(): Promise<any> {
    const query = JSON.stringify({ screenCustomer: this.data.customer._id });
    let params = '?query=' + encodeURIComponent(query);
    params += '&target=analytic-logs';
    params += '&api_key=' + encodeURIComponent(this.apiKey);
    return this.bulkRemoveByIds(this.analyticLogsService, params).then(result => {
      if (result && result.data) {
        this.protocol.analyticLogsCount = result.data.count;
      }
      return Promise.resolve(true);
    });
  }

  /* helpers */

  private initProtocol() {
    this.protocol = {};
    this.statusInfo = null;
    this.error = null;
    this.protocol.title = this.title;
    this.protocol.type = 'customer';
    this.protocol.isDeleted = true;
    this.protocol.initialData = this.data.customer;
    this.protocol.log = [];
    this.protocol.importIds = [];
    this.protocol.screenUuids = [];
    this.protocol.screenIds = [];
    this.protocol.legacyComposition = [];
    this.protocol.errorRemoveByIds = 0;
  }

  private removeByIds(service, ids, bubbleError = false): Promise<any> {
    let errors = 0;
    if (this.cancel) {
      throw new Error('canceled');
    }
    const promises = ids.map(id => {
      if (this.cancel) {
        throw new Error('canceled');
      }
      if (this.isTest) {
        return service.get(id).catch(err => {
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('not found: ' + service.provider.endpointName + ', ' + id + ': ' + error);
          errors++;
          return Promise.resolve(true);
        });
      } else {
        if (bubbleError) {
          return service.remove(id);
        }
        return service.remove(id).catch(err => {
          console.log('error on removing: ', id, err);
          const error = err && err.error && err.error.message ? err.error.message : err;
          this.protocol.log.push('Error removing: ' + service.provider.endpointName + ', ' + id + ': ' + error);
          errors++;
          return Promise.resolve(true);
        });
      }
    });
    return Promise.all(promises).then(() => {
      return Promise.resolve(ids.length - errors);
    });
  }

  private bulkRemoveByIds(service, params): Promise<any> {
    let backendUrl = environment.apiBaseURL;
    if (this.ms.getActiveAPI() === 'live' || this.ms.getActiveAPI() === 'staging') {
      backendUrl = environment[this.ms.getActiveAPI()].apiBaseURL;
    }
    if (this.cancel) {
      throw new Error('canceled');
    }
    if (this.isTest) {
      return this.http.get(backendUrl + '/bulkRemove' + params).toPromise().then(result => {
        return result;
      }).catch(err => {
        const error = err && err.error && err.error.message ? err.error.message : err;
        this.protocol.log.push('error on bulk-finding: ' + service.provider.endpointName + ': ' + error);
        return Promise.resolve(true);
      });
    } else {
      return this.http.delete(backendUrl + '/bulkRemove' + params).toPromise().then(result => {
        return result;
      }).catch(err => {
        const error = err && err.error && err.error.message ? err.error.message : err;
        this.protocol.log.push('error on bulk-remvoe: ' + service.provider.endpointName + ': ' + error);
        return Promise.resolve(true);
      });
    }
  }

  private generateRandom(amount) {
    const code = [];
    for (let i = 0; i < amount; i++) {
      code.push(Math.floor(Math.random() * 10));
    }
    return code.join('');
  }

  private saveProtocol(error = null): Promise<any> {
    if (error) {
      this.error = error && error.error && error.error.message ? error.error.message : error;
      this.protocol.errror = error;
    } else {
      this.protocol.success = true;
    }
    const protocol = new Models.AccommodationWizardIds();
    protocol.processedData = this.protocol;
    if (this.isTest) {
      console.log(this.protocol)
      return Promise.resolve(true);
    }
    return this.accommodationWizardIdsService.create(protocol).then(result => {
      console.log('wrote data: ', result);
      this.snackbar.open('protocol saved to wizard data ( you find this under userManagement ')
      return Promise.resolve(true);
    });
  }

}
